import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconLetter({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="#fff">
				<path d="M13.283 14.221a2.1 2.1 0 0 1-1.283.367 2.1 2.1 0 0 1-1.283-.367L1 9v9.252A2.75 2.75 0 0 0 3.75 21h16.5c1.519 0 2.75-1.23 2.75-2.748V9z" />
				<path d="M20.25 3H3.75C2.231 3 1 4.22 1 5.726v.91a.95.95 0 0 0 .458.817l10.084 5.453c.14.073.3.105.458.09a.83.83 0 0 0 .458-.09l10.084-5.453A.95.95 0 0 0 23 6.635v-.909C23 4.221 21.769 3 20.25 3" />
			</g>
		</svg>
	);
}
